"use client";

import { useSidebar } from "@src/components/ui/sidebar";
import Link from "next/link";
import { ComponentProps, forwardRef } from "react";

/**
 * A wrapper around Link that automatically closes the mobile sidebar when clicked.
 * This component should be used for all navigation links within the Sidebar component.
 */
export const SidebarLink = forwardRef<HTMLAnchorElement, ComponentProps<typeof Link>>((props, ref) => {
  const {
    setOpenMobile
  } = useSidebar();
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    setOpenMobile(false);

    // Call the original onClick handler if provided
    props.onClick?.(e);
  };
  const handleAuxClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    setOpenMobile(false);

    // Call the original onAuxClick handler if provided
    props.onAuxClick?.(e);
  };
  return <Link {...props} ref={ref} onClick={handleClick} onAuxClick={handleAuxClick} />;
});
SidebarLink.displayName = "SidebarLink";